import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { UpdateUserPlanFormType } from '../Pages/Frontend/Components/User/EditUserPlan/EditUserPlan'
import { employeeFormType } from 'Pages/Frontend/Interface/Admin/Users/UsersDetails/UsersDetails'
import { addEmployeeFormType } from 'Pages/Frontend/Components/User/AddUser/AddUser'
import { IExitForm } from 'Models'

AxiosInterceptor()

const employeeService = {
  index: async (
    pageNumber: number,
    sortOrder: string,
    loanProvider?: string | undefined,
    tradersCardNumberStatus?: boolean | undefined,
    allEmployees?: boolean | undefined,
  ) => {
    if (!loanProvider) {
      if (tradersCardNumberStatus !== undefined) {
        return await axios.get(
          `/admin/employee?pageNumber=${pageNumber}&sortOrder=${sortOrder}&hasPlpTradersCardNumber=${tradersCardNumberStatus}`,
        )
      } else if (allEmployees !== undefined) {
        return await axios.get(
          `/admin/employee?pageNumber=${pageNumber}&createdAt=${sortOrder}&includeTerminatedEmployees=${allEmployees}`,
        )
      }
      return await axios.get(`/admin/employee?pageNumber=${pageNumber}&sortOrder=${sortOrder}`)
    } else {
      if (tradersCardNumberStatus !== undefined) {
        return await axios.get(
          `/admin/employee?pageNumber=${pageNumber}&sortOrder=${sortOrder}&loanProvider=${loanProvider}&hasPlpTradersCardNumber=${tradersCardNumberStatus}`,
        )
      }
      return await axios.get(
        `/admin/employee?pageNumber=${pageNumber}&sortOrder=${sortOrder}&loanProvider=${loanProvider}`,
      )
    }
  },

  empGetUsers: async (pageNumber?: number, excludeSelf?: boolean) => {
    return await axios.get(
      `/employee/users?pageNumber=${pageNumber}&excludeSelf=${excludeSelf}`,
    )
  },
  lineManagerIndex: async (pageNumber: number, lineManagerUserId?: string | undefined) => {
    return await axios.get(
      `/admin/employee?pageNumber=${pageNumber}&lineManagerUserId=${lineManagerUserId}`,
    )
  },

  kpiIndex: async (userId: string | undefined) => {
    return await axios.get(`/kpis?userId=${userId}`)
  },

  kpiCreate: async (data: { relevance?: number; metric: string; userId: string | undefined }) => {
    return await axios.post('/kpis', data)
  },

  kpiDelete: async (id: number) => {
    return await axios.delete(`/kpis/delete?kpiId=${id}`)
  },

  kpiUpdate: async (data: { relevance: number; metric: string; id: string | undefined }) => {
    const {id, ...rest} = data;
    return await axios.patch(`/kpis/${data.id}`, rest)
  },

  update: async (employeeId: string | undefined, data: employeeFormType) => {
    return await axios.put(`/admin/employee/${employeeId}`, data)
  },

  approveProfileUpdate: (employeeId: string) => {
    return axios.put(`/admin/employee/${employeeId}`, {
      isProfileUpdateApproved: true,
    })
  },

  getLoggedUser: () => {
    return axios.get('/employee/profile')
  },

  getAllEmployees: () => {
    return axios.get('/employee/users')
  },

  fillExitForm: async (data: IExitForm) => {
    return axios.post('/employee/profile/exit-form', data)
  },

  getSingleExitForm: async (pageNumber: number, userId: string | undefined) => {
    return axios.get(`/admin/employee/exit-forms?pageNumber=${pageNumber}&userId=${userId}`)
  },

  getExitForms: async (pageNumber: number) => {
    return axios.get(`/admin/employee/exit-forms?pageNumber=${pageNumber}`)
  },

  createNew: (payload: addEmployeeFormType) => {
    return axios.post('/admin/employee/onboard', payload)
  },

  triggerExitForm: async (id: string) => {
    return await axios.post(`/admin/employee/offboard/${id}`)
  },

  terminateEmployee: async (id: string) => {
    return await axios.post(`/admin/employee/terminate-employee/${id}`)
  },

  allCustomers: () => {
    return axios.get('/customers?pageNumber=1&sortOrder=DESC')
  },

  searchCustomer: async (endpoint: string, pageNumber: number, sortOrder: string) => {
    const queryParams = `${endpoint}&pageNumber=${pageNumber ?? 1}&sortOrder=${sortOrder}`
    return await axios.get(`admin/employee?${queryParams}`)
  },

  updatePlan: (msisdn: string | undefined, payload: UpdateUserPlanFormType) => {
    return axios.put(`/customers/accountplan?msisdn=${msisdn}`, payload)
  },

  getDetails: (customerAccountId: string | undefined) => {
    return axios.get(`/admin/employee/${customerAccountId}`)
  },

  getUserLPs: (msisdn: string | undefined) => {
    return axios.get(`/customers/${msisdn}/loanproviders`)
  },

  updateMultiPlp: (msisdn: string | undefined, enableOrDisable: string) => {
    return axios.post(`/customers/${msisdn}/enableMultiplePLP/${enableOrDisable}`)
  },

  searchCustomerName: async (
    firstName: string | undefined,
    lastName: undefined | string,
    pageNumber: number,
    sortOrder: string,
  ) => {
    let url = 'customers'

    if (firstName) {
      url += `?firstName=${firstName}`
    }

    if (lastName) {
      url += firstName ? `&lastName=${lastName}` : `?lastName=${lastName}`
    }

    url += `&pageNumber=${pageNumber ?? 1}&sortOrder=${sortOrder}`
    return await axios.get(url)
  },
}

export default employeeService
